module.exports = __webpack_public_path__ + "img/Z71_03.a2638f77.jpg";